<template>
  <!-- 落地页pro -->
  <div class="sempro">
    <!-- 头部banner+表单 -->
    <BannerForm
      title="免费试用"
      :pcBgImg="pcBgImg"
      :landingPageName="landingPageName"
      :showForm="!showScrollForm"
      :logoSrc="logoSrc"
      @msg="handleShowMsg"
      @setShowSuccessDialog="setShowSuccessDialog"
      setHeight="540"
    >
      <template slot="title">
        <div class="sempro-title-content">
          <div class="one-line">签管一体化电子合同云平台</div>
          <div class="two-line">从签到管，开箱即用</div>
        </div>
      </template>
      <template slot="desc">
        <div class="sempro-desc">好用：深入实践的签署能力，全链路体验升级</div>
        <div class="sempro-desc">智能：多通道垂直大模型，签管效率全面提升</div>
        <div class="sempro-desc">安全：三大策略保障数据安全，降低业务风险</div>
      </template>
    </BannerForm>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- e签宝云平台 -->
    <div class="product-package">
      <SectionCard :isPcFlag="true" title="e签宝签管一体化电子合同云平台">
        <div class="package-title-content">
          <div class="package-center">
            <div class="package-item" v-for="item in packageTitleData" :key="item.key">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.desc }}</div>
            </div>
          </div>
          <img class="connect-img" src="../../assets/images/sem-pro/editions/editions_banner.png" alt="" />
        </div>
        <!-- 具体套餐 -->
        <div class="product-content">
          <div class="card-item" v-for="item in systemList" :key="item.key">
            <img class="system-img" :src="item.imgSrc" alt="" />
            <div class="card-item-content">
              <div class="title">{{ item.title }}</div>
              <button class="item-button" v-if="item.key == 1" @click="showDialog">
                {{ item.buttonText }}
              </button>
              <button class="item-button" v-else @click="OnlineConsultationClick">
                {{ item.buttonText }}
              </button>
              <div class="desc">
                <p v-for="(it, index) in item.descList" :key="index">
                  {{ it }}
                </p>
              </div>
              <div class="kind-list">
                <div class="kind-item" v-for="i in item.kindList" :key="i.key">
                  <img class="kind-img" :src="i.icon" alt="" />
                  <p class="kind-text">{{ i.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="button-operation">
          <div>
            <div class="btn mfsy" @click="showDialog">免费试用</div>
            <div class="desc">注册可得5份合同试用</div>
          </div>
          <div>
            <div class="btn zxzx" @click="OnlineConsultationClick">在线咨询</div>
            <div class="desc">如需购买或了解更多套餐</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <div class="batch-content">
      <div class="batch-title">批量发起，批量审批签署</div>
      <div class="batch-desc">专业版及以上支持</div>
      <img src="../../assets/images/sem-pro/batch/batch_launch_display.png" alt="batch_display" />
      <div class="btns-box">
        <div class="btns">
          <div class="mfsy" @click="showDialog">免费试用</div>
          <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
        </div>
      </div>
    </div>
    <!-- api接口能力展示 -->
    <div class="api_interface_content">
      <div class="api_title">API接口开放，系统快速对接</div>
      <div class="api_desc">专业版及以上支持</div>
      <img src="../../assets/images/sem-pro/api_interface/api_interface_show.png" alt="" />
      <div class="btns-box">
        <div class="btns">
          <div class="mfsy" @click="showDialog">立即接入</div>
          <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
        </div>
      </div>
    </div>
    <!-- 高级版功能亮点 -->
    <PreHighLight :dataList="preHighLightList" :isPcFlag="isPcFlag"></PreHighLight>

    <div class="oversea-con">
      <h2>e签宝海外签</h2>
      <h3>助力中资出海/外企跨境签署</h3>
      <div class="oversea-main">
        <div class="desc">
          <div class="desc-item">全球74+国家/地区合规电子签名</div>
          <div class="desc-item">支持SES/AES/QES电子签</div>
          <div class="desc-item">香港/新加坡/法兰克福三大数据中心</div>
          <div class="desc-item">香港/新加坡均有设立分支服务机构</div>
        </div>
      </div>
      <button class="free-b" @click="showDialog">免费试用</button>
    </div>

    <!-- 行业实践解决方案 -->
    <SolutionList class="solution-saas" :title="solutions.title" :solutionList="solutions.list" @showDialog="showDialog" />
    <!-- 安全可靠的电子合同服务 -->
    <div class="safe-reliable">
      <SectionCard :isPcFlag="true" title="安全可靠的电子合同服务" bgColor="#f7f7f9">
        <div class="content">
          <div class="card" v-for="(item, index) in safeReliableData" :key="index">
            <img :src="item.img" alt="" />
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 客户案例 -->
    <OrgList class="customer-cases" :title="orgList.title" :orgTypeList="orgList.orgTypeList" :imgs="orgList.imgs" />
    <!-- 底部备案信息 -->
    <FooterBasis />
    <!-- 左侧计算机小象 -->
    <LeftBar />
    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" :wlCode="true" />
    <!-- 右侧客服 -->
    <!--    <Contact :landingPageName="landingPageName" :saasApiContact="true" />-->
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu.js'
export default {
  name: 'semPro',
  mixins: [qiyuMixin],
  components: {
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    SolutionList: () => import('@/views/extension/components/pc/SolutionList.vue'),
    OrgList: () => import('@/views/extension/components/pc/OrgList.vue'),
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    // Contact: () => import('@/components/Contact.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
    PreHighLight: () => import('./components/PreHighLight.vue'),
  },
  data() {
    return {
      isPcFlag: true,
      logoSrc: require('@/assets/images/real-estate/new_logo.png'),
      pcBgImg: require('@/assets/images/sem-saas/banner-bg.png'),
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
      qrCodeImg: require('@/assets/images/sem-saas/flow-qr-code.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      systemList: dataList.systemList,
      bannerBottomData: dataList.bannerBottomData,
      packageTitleData: dataList.packageTitleData,
      electronicCard: dataList.electronicCard,
      flowPathOneLine: dataList.flowPathOneLine,
      flowPathTwoLine: dataList.flowPathTwoLine,
      solutions: dataList.solutions,
      safeReliableData: dataList.safeReliableData,
      saasAiData: dataList.saasAiData,
      orgList: dataList.orgList,
      preHighLightList: dataList.preHighLightList,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
    this.addQiyuScript()
  },
  computed: {
    qrCodeUrl() {
      return this.$store.state.user.wlQrcode || ''
    },
  },
  methods: {
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    OnlineConsultationClick() {
      if (this.RoutingJudgment) {
        this.handleCustomerServiceBaiduClick({ templateId: 6641070 })
      } else {
        // this.handleCustomerServiceClick({ entry: 'yinzhangsecordpage' })
        this.handleNewBaiduService()
      }
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    getWeilQrCode() {
      // eslint-disable-next-line no-undef
      wlQrcodeCustomComp.getQrCodeUrl(
        {
          wl_qrcode_id: '1683768809598779392', // [修改1：将wl_qrcode_id粘贴至此]
        },
        (resData) => {
          const { code, data } = resData
          if (code === 200 && data) {
            if (data.qr_code) {
              // data中包含二维码图片地址
              this.qrCodeUrl = data.qr_code
              clearTimeout(this.timer)
            }
          }
        }
      )
    },
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
